'use client';
/**
 * DevOverlayGuard — injecte du CSS pour masquer l'overlay Next.js dev
 * aux utilisateurs non-admin. Les admins voient toujours les erreurs.
 */
import { useEffect }   from 'react';
import { useIsAdmin }  from '@/hooks/useIsAdmin';

export default function DevOverlayGuard() {
  const { isAdmin, isLoaded } = useIsAdmin();

  useEffect(() => {
    if (!isLoaded) return;
    if (!isAdmin) {
      const style = document.createElement('style');
      style.id = 'hide-dev-overlay';
      style.textContent = [
        'nextjs-portal { display: none !important; }',
        'body > [data-nextjs-dialog-overlay] { display: none !important; }',
      ].join(' ');
      document.head.appendChild(style);
    }
  }, [isLoaded, isAdmin]);

  return null;
}
